import { FETCH_ME, RESET_ME } from "../../constants/action.constants";

const initialState = {
  data: {},
};

const meReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ME:
      return { data: action.payload };
    case RESET_ME:
      return initialState;
    default:
      return state;
  }
};

export default meReducer;
